/* eslint-disable react/jsx-handler-names */
import './PriceHistoryTooltip.css';

import React from 'react';
import { createPortal } from 'react-dom';

import classname from '@search/classname/src';

import { usePopper } from '../popper/usePopper';
import { useToggleChain } from '../popper/useToggleChain';
import { useClassifiedOfferDataLayerPush } from '../../../../../domain/offer/analytics/ClassifiedOfferGtmContext';
import { PriceHistoryPart } from './PriceHistoryPart';
import { PriceHistoryPlot } from './PriceHistoryPlot';
import { PriceHistoryTable } from './PriceHistoryTable';

const cn = classname.bind(null, 'PriceHistoryTooltip');

export function PriceHistoryTooltip({
    lock,
    hide,
    triggerElement,
    history,
    // renderSubscribeToPrice
}: {
    lock(isLocked: boolean): void;
    history: readonly PriceHistoryPart[];
    renderSubscribeToPrice?: React.ReactNode;
} & Parameters<typeof usePopper>[0]) {
    const spy = useToggleChain({
        lock,
        leaveTimeout: 250
        // debugLabel: 'PriceHistoryTooltip',
    });
    const setTooltipElement = usePopper({ direction: 'down', triggerElement, hide });

    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const onMouseEnter = (e:React.MouseEvent<HTMLElement>) => {
        dataLayerPush({ event: 'classified_pr_subscr_offer_click' });
        spy.show(e);
    };

    return createPortal(
        <div
            ref={setTooltipElement}
            onMouseEnter={onMouseEnter}
            onMouseLeave={spy.hide}
            className={cn()}
        >
            {history.length > 3 ?
                <PriceHistoryPlot history={history} /> :
                <PriceHistoryTable history={history} />
            }
            {/*{renderSubscribeToPrice}*/}
        </div>,
        document.body
    );
}
